import type { CSSProperties, ReactNode } from 'react';

export type DossierFolderProps = {
  /** Tab label (e.g. "DOSSIER · 02/06"). */
  tabLabel?: ReactNode;
  /** Top-right stamp (rendered absolute). Typically a `<Stamp tone='red'>CONFIDENTIEL</Stamp>`. */
  stamp?: ReactNode;
  rot?: number;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

/**
 * Manila folder body used as the pass-the-device surface. Renders the
 * `.folder-manila` recipe (diagonal hatch + warm gradient + drop shadow)
 * with a small file tab clamped on the top-left and an optional stamp
 * absolutely placed top-right. Children sit inside the folder — usually
 * a paper card with the recipient's name.
 */
export const DossierFolder = ({
  tabLabel,
  stamp,
  rot = -1.5,
  className,
  style,
  children,
}: DossierFolderProps) => {
  return (
    <div
      className={['folder-manila relative', className ?? ''].filter(Boolean).join(' ')}
      style={{
        transform: `rotate(${rot}deg)`,
        padding: 28,
        ...(style ?? {}),
      }}
    >
      {tabLabel !== null && (
        <div
          style={{
            position: 'absolute',
            top: -22,
            left: 28,
            background: '#c39556',
            padding: '4px 14px',
            border: '2px solid #a87a3e',
            borderBottom: 'none',
            borderRadius: '4px 4px 0 0',
            fontFamily: 'var(--font-display)',
            fontWeight: 800,
            fontSize: 10,
            letterSpacing: '.22em',
            color: 'rgba(0,0,0,.55)',
          }}
        >
          {tabLabel}
        </div>
      )}
      {stamp !== null && <div style={{ position: 'absolute', top: 16, right: 14 }}>{stamp}</div>}
      {children}
    </div>
  );
};
